module.exports = __webpack_public_path__ + "img/accumulator.3ea47c63.png";